import {EventListener, EventVerteiler} from "@k/global/eventVerteiler";
import {displayFadeoutMessageToUser} from "@km/components/popups/MessageToDisplayContainer";

import {DIALOGS} from "@k/global/dialogDefinitions";
import {NthIterationExecutor} from "@k/global/nthIterationExecutor";
import {existsLastLoggedInUserCookie, noop} from "@k/global/globalUtils";
import {UserModuleNames} from "@km/components/user/UserModulesAnimations";
import {displayAcknowledgePopup, displayTwoButtonDialog} from "./ConfirmOrConfirmCancelDialog";


export function initMessageToUserEventListeners(store, translate:(string)=>string) {
    const e = new EventListener();
    const notLoggedInWarner = getNotLoggedInWarner(store);
    e.addEventListener("userLoggedInEvent", ({username})=>displayFadeoutMessageToUser([translate("konf_hello"), username].join(" ")));
    e.addEventListener("userLoggedOutEvent", ()=>displayFadeoutMessageToUser(translate("km_goodbye")));
    e.addEventListener("displayHintEvent", ({message})=>displayFadeoutMessageToUser(message));
    e.addEventListener("displayHintEventToBeTranslated", ({message})=>displayFadeoutMessageToUser(translate(message)));
    e.addEventListener("displayDialogEvent", ({dialog, callbacks, messageAddition=""})=>displayDialog(dialog, callbacks, messageAddition, translate));
    e.addEventListener("displayNotLoggedInWarningEvent", ()=>notLoggedInWarner.execute("warningNotLoggedIn"));
}

const getNotLoggedInWarner = store=>new NthIterationExecutor(function (dialog) {
    if (existsLastLoggedInUserCookie()) {
        dialog = "warningNotLoggedInReLogin";
    }
    EventVerteiler.broadcast("displayDialogEvent", {
        dialog: dialog,
        callbacks: [() => { }, () => store.commit("OPEN_USERLAYER", UserModuleNames.login)]
    });
}, 5);


function displayDialog(dialog:string, callbacks:(()=>void)[], messageAddition, translate) {
    switch(dialog) {
        case "shareOnFacebook":
            displayAcknowledgePopup(translate(DIALOGS.shareOnFacebook.title.id), translate(DIALOGS.shareOnFacebook.message.id)).then(callbacks[0]);
            return;
        case "mailSentTo":
            displayAcknowledgePopup(translate(DIALOGS.mailSentTo.title.id), translate(DIALOGS.mailSentTo.message.id)+" "+messageAddition);
            return;
        case "deleteObjectOutOfDruckbereich":
            const dialogToDisplay = DIALOGS.deleteObjectOutOfDruckbereich;
            displayTwoButtonDialog(
                translate(dialogToDisplay.title.id),
                translate(dialogToDisplay.message.id),
                translate(dialogToDisplay.buttons[0].text.id), translate("konf_Cancel"))
                .then(callbacks[0]).catch(noop)
            return;
        case "displayNotLoggedInWarningEvent":
        case "warningNotLoggedIn":
        case "warningNotLoggedInReLogin":
            const notLoggedInWarning = DIALOGS.warningNotLoggedIn;
            displayTwoButtonDialog(
                translate(notLoggedInWarning.title.id),
                translate(notLoggedInWarning.message.id),
                translate(notLoggedInWarning.buttons[1].text.id), translate(notLoggedInWarning.buttons[0].text.id))
                .then(callbacks[1]).catch(noop);
            return;
        case "draftInShop":
            displayAcknowledgePopup(translate(DIALOGS.draftInShop.title.id), translate(DIALOGS.draftInShop.message.id)).then(callbacks[0]);
            return;
        case "draftIsRdyDesign":
            displayAcknowledgePopup(translate(DIALOGS.draftIsRdyDesign.title.id), translate(DIALOGS.draftIsRdyDesign.message.id)).then(callbacks[0]);
    }
}
